module.exports = __webpack_public_path__ + "img/computer-mouse-scrollwheel.49f305c2.svg";